export const ALLOWED_DOCUMENT_MIME_TYPES: string[] = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'text/plain',
  'text/csv',
]

/** Extensions accepted when the browser reports an empty file.type (e.g. on Windows for .txt). */
const ALLOWED_DOCUMENT_EXTENSIONS = new Set([
  'pdf',
  'doc', 'docx',
  'xls', 'xlsx',
  'ppt', 'pptx',
  'odt', 'ods', 'odp',
  'txt', 'csv',
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'svg', 'webp', 'avif',
])

export const ALLOWED_DOCUMENT_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp,.txt,.csv,image/*'

export function isAllowedDocumentType(file: File): boolean {
  if (file.type) {
    if (file.type.startsWith('image/')) return true
    return ALLOWED_DOCUMENT_MIME_TYPES.includes(file.type)
  }
  // Fallback: some browsers/OS report empty file.type for known extensions
  const ext = file.name.split('.').pop()?.toLowerCase() ?? ''
  return ALLOWED_DOCUMENT_EXTENSIONS.has(ext)
}
